import AuthenticatedUser from "./AuthenticatedUser";

export default AuthenticatedUser;
